import { render, staticRenderFns } from "./QesIdentify.vue?vue&type=template&id=537a8e07&scoped=true&"
import script from "./QesIdentify.vue?vue&type=script&lang=js&"
export * from "./QesIdentify.vue?vue&type=script&lang=js&"
import style0 from "./QesIdentify.vue?vue&type=style&index=0&id=537a8e07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a8e07",
  null
  
)

export default component.exports